import React, { useContext } from 'react';
import { Button, Col, DatePicker, Form, Input, Row } from 'antd';
import styled from '@emotion/styled';
import { colors } from '@atlaskit/theme';
import InputMoney from '@/components/InputMoney';
import { DrapItemContext } from './DrapItemContext';
import styles from './index.module.scss';

const { TextArea } = Input;

type Props = {
  name?: any;
  quote?: any;
  isDragging: boolean;
  provided: any;
  isClone?: boolean;
  isGroupedOver?: boolean;
  style?: Object;
  index?: number;
};

const borderRadius = 2;
const grid = 8;
const imageSize: number = 40;

const getBackgroundColor = (isDragging: boolean, isGroupedOver: boolean) => {
  if (isDragging) {
    // return authorColors?.soft;
    return 'rgba(63, 121, 255, 0.1)';
  }

  if (isGroupedOver) {
    return colors.N30;
  }

  return colors.N0;
};

const getBorderColor = (isDragging: boolean, authorColors: any) =>
  isDragging ? authorColors?.hard : 'transparent';

const Container = styled.a`
  border-radius: ${borderRadius}px;
  border: 2px solid transparent;
  border-color: ${(props) => getBorderColor(props.isDragging, props.colors)};
  background-color: ${(props) =>
    getBackgroundColor(props.isDragging, props.isGroupedOver, props.colors)};
  box-shadow: ${({ isDragging }) => (isDragging ? `2px 2px 1px ${colors.N70}` : 'none')};
  box-sizing: border-box;
  /* padding: ${grid}px; */
  min-height: ${imageSize}px;
  margin-bottom: ${grid}px;
  user-select: none;

  /* anchor overrides */
  color: ${colors.N900};

  &:hover,
  &:active {
    color: ${colors.N900};
    text-decoration: none;
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  /* flexbox */
  display: flex;
`;
// const Avatar = styled.img`
//   width: ${imageSize}px;
//   height: ${imageSize}px;
//   border-radius: 50%;
//   margin-right: ${grid}px;
//   flex-shrink: 0;
//   flex-grow: 0;
// `;

// const Content = styled.div`
//   /* flex child */
//   flex-grow: 1;

//   /*
//     Needed to wrap text in ie11
//     https://stackoverflow.com/questions/35111090/why-ie11-doesnt-wrap-the-text-in-flexbox
//   */
//   flex-basis: 100%;

//   /* flex parent */
//   display: flex;
//   flex-direction: column;
// `;

// const BlockQuote = styled.div`
//   &::before {
//     content: open-quote;
//   }

//   &::after {
//     content: close-quote;
//   }
// `;

// const Footer = styled.div`
//   display: flex;
//   margin-top: ${grid}px;
//   align-items: center;
// `;

// const Author = styled.small`
//   color: ${(props) => props.colors.hard};
//   flex-grow: 0;
//   margin: 0;
//   background-color: ${(props) => props.colors.soft};
//   border-radius: ${borderRadius}px;
//   font-weight: normal;
//   /* padding: ${grid / 2}px; */
// `;

// const QuoteId = styled.small`
//   flex-grow: 1;
//   flex-shrink: 1;
//   margin: 0;
//   font-weight: normal;
//   text-overflow: ellipsis;
//   text-align: right;
// `;

function getStyle(provided: any, style: any) {
  if (!style) {
    return provided.draggableProps.style;
  }

  return {
    ...provided.draggableProps.style,
    ...style,
  };
}

function QuoteItem(props: any) {
  const { name, quote, isDragging, isGroupedOver, provided, style, isClone, index } = props;
  const values = useContext(DrapItemContext);
  // 动态表单内容
  const { dynamicFormAttr, removeFn } = values;

  const renderField = (row: number, item: any) => {
    const { label, type, fieldProps } = item || {};
    const { onBlur, ...rest } = fieldProps || {};
    let node = <Input placeholder={label} />;
    if (type === 'dateTime') {
      node = <DatePicker placeholder={`请选择${label}`} showTime />;
    }
    if (type === 'textArea') {
      node = <TextArea autoSize placeholder={label} />;
    }
    if (type === 'inputMoney') {
      node = (
        <InputMoney
          placeholder={label}
          onBlur={(e) => (onBlur ? onBlur(e.target.value, row) : null)}
        />
      );
    }
    return React.cloneElement(node, { ...rest });
  };

  return (
    <Container
      isDragging={isDragging}
      isGroupedOver={isGroupedOver}
      isClone={isClone}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      style={getStyle(provided, style)}
      data-is-dragging={isDragging}
      data-testid={quote?.id}
      data-index={index}
      // aria-label={`${quote.author.name} quote ${quote.content}`}
    >
      {/* <Avatar src={quote.author.avatarUrl} alt={quote.author.name} />
      <Content>
        <BlockQuote>{quote.content}</BlockQuote>
        <Footer>
          <Author colors={quote.author.colors}>{quote.author.name}</Author>
          <QuoteId>id:{quote.id}</QuoteId>
        </Footer>
      </Content> */}
      <Row className={styles.bodyRow} gutter={[8, 0]}>
        <Col span={2}>
          <Form.Item>
            <div className={styles.dragBtn}>&nbsp;</div>
          </Form.Item>
        </Col>

        {dynamicFormAttr?.map((item) => (
          <Col key={item.key} span={item.span}>
            <Form.Item name={[name, item.key]} rules={item.rules}>
              {renderField(name, item)}
            </Form.Item>
          </Col>
        ))}

        <Col span={1}>
          <Form.Item>
            <Button type="link" onClick={() => removeFn(name)} style={{ cursor: 'pointer' }}>
              删除
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Container>
  );
}

export default React.memo<Props>(QuoteItem);
